import React from "react";

import VisaSVG from "../../../../public/icons/payment/visa.svg";
import PaypalSVG from "../../../../public/icons/payment/paypal.svg";
import SEPASVG from "../../../../public/icons/payment/sepa.svg";
import GoogleSVG from "../../../../public/icons/payment/google-pay.svg";
import AppleSVG from "../../../../public/icons/payment/apple-pay.svg";

import styles from './shCheckoutPaymentChoose.module.scss';
import ShSelectionButton from "../../../../components/selectionButton/shSelectionButton";
import { ShCheckoutFooterButton } from "../helper/components/footerButton/shCheckoutFooterButton";
import ShPaymentFriendlyName from "./shPaymentFriendlyName";
import { ShCheckoutReturnPolicyInfo } from "../helper/components/shCheckoutReturnPolicyInfo";
import ShNewModalWrapper from "../../../../components/modal/shNewModalWrapper";

const ShCheckoutGenericPaymentChoose = (
    {
        paymentMethod,
        setPaymentMethod,

        modalHeader = <></>,
        hideModal = () => { },

        selectedPaymentMethod = (paymentMethod: string) => { },
        footerAddition = null
    }
) => {

    const footer = <>

        { footerAddition }

        <ShCheckoutFooterButton
            disabled={!paymentMethod}
            onClick={
                () => {
                    if (paymentMethod) {
                        selectedPaymentMethod(paymentMethod)
                    }
                }
            }>
            Weiter { paymentMethod && " mit" } <ShPaymentFriendlyName paymentMethod={paymentMethod} />
        </ShCheckoutFooterButton>

        <ShCheckoutReturnPolicyInfo />
    </>

    return  <ShNewModalWrapper title={"Bezahlen"}
                               subtitle="Zahlungsmethode wählen"
                               header={modalHeader}
                               onRequestClose={hideModal}
                               footer={footer}>

        <ShSelectionButton
            className="py-3"
            checked={ paymentMethod === "paypal"}
            checkedChange={ () => setPaymentMethod("paypal") }>

            <PaypalSVG  className={styles.paymentChoose}/>

        </ShSelectionButton>

        <ShSelectionButton
            className="py-3"
            checked={ paymentMethod === "creditcard" }
            checkedChange={ () => { setPaymentMethod("creditcard")} } >
            <div className={"d-flex align-items-center"}>
                <VisaSVG  className={styles.paymentChoose}/>
                <GoogleSVG className={styles.googleSVG + " ml-2 mr-1"}/>
                <AppleSVG className={styles.appleSVG}/>
            </div>
        </ShSelectionButton>

        <ShSelectionButton
            className="py-3"
            checked={ paymentMethod === "sepa" }
            checkedChange={
                () => { setPaymentMethod("sepa") }
            }>
            <SEPASVG className={styles.paymentChoose}/>
        </ShSelectionButton>

    </ShNewModalWrapper>

};

export default ShCheckoutGenericPaymentChoose;
